import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-up"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 11L11.5 2.5L11.9932 2.5822C13.4398 2.82329 14.5 4.07486 14.5 5.54138V9H20.8195C21.4375 9 21.9075 9.55487 21.8059 10.1644L20.1393 20.1644C20.0589 20.6466 19.6417 21 19.1529 21H8V11Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 21V11M8 11V21H19.1529C19.6417 21 20.0589 20.6466 20.1393 20.1644L21.8059 10.1644C21.9075 9.55487 21.4375 9 20.8195 9H14.5V5.54138C14.5 4.07486 13.4398 2.82329 11.9932 2.5822L11.5 2.5L8 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbUp = Vue.extend<IconProps>({
  name: 'ThumbUpIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'thumb-up',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ThumbUp;
